import React, { useState, useEffect, useContext } from 'react'
import TodaysSalesStyle from './css/TodaysSalesStyle'
import { appContext } from '../../../../App'
import { formatNumber, simpleDateString, dateYMD } from '../../../utilities/utilities'
import { getProductsSoldReport } from '../../../reports/ReportsFunctions'

function TodaysSales() {
  const app = useContext(appContext)
  const { getClientDateTime } = app
  const [productsSold, setProductsSold] = useState(null)
  const [totalSales, setTotalSales] = useState(0)

  const [date, setDate] = useState((new Date(getClientDateTime())))

  // These dates are time zoned.
  const today_start = dateYMD(date)
  const today_end = dateYMD(date)

  useEffect(() => {
    let isMounted = true 

    const init = async (silent) => {
      const products_sold = await getProductsSoldReport(app, { from: today_start, to: today_end }, silent)
      if (isMounted) setProductsSold(products_sold)
    }

    if (isMounted) init(false)

    // Update every one second
    const timerID = setInterval(() => {
      if (isMounted) {
        setDate((new Date(getClientDateTime())))
        init(true)
      }
    }, 1000)

    return(() => {
      isMounted = false 
      clearInterval(timerID)
    })
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (productsSold) {
      setTotalSales(productsSold.reduce((acc, cur) => (acc + cur.total_amount_sold), 0))
    }

    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productsSold])

  return (
    <React.Fragment>
      <div className='todays-sales-container'>
        <div className='card-container'>
          <div className='title-container'>
            <h4>Today Sale's</h4>
          <h2>P{formatNumber(totalSales)}</h2>
          </div>
          <div className='date-container'>
            <div>{simpleDateString(date)}</div>
            <div><b>{date.toLocaleTimeString()}</b></div>
          </div>
        </div>
        <br />
        <div className='products-sold-table-container'>
          <table className='products-sold-table'>
            <thead>
              <tr>
                <th style={{textAlign: 'left'}}>Product Name</th>
                <th style={{textAlign: 'left'}}>Unit</th>
                <th>Quantity Sold</th>
                <th style={{textAlign: 'right'}}>Price Sold Total</th>
              </tr>
            </thead>
            {
              (productsSold)
              ? productsSold.map((ps, index) => (
                  <tbody key={index}>
                    <tr>
                      <td>{ps.item_name}</td>
                      <td>{ps.item_unit}</td>
                      <td style={{textAlign: 'center'}}>{formatNumber(ps.total_quantity_sold)}</td>
                      <td style={{textAlign: 'right'}}>P{formatNumber(ps.total_amount_sold)}</td>
                    </tr>
                  </tbody>
                ))
              : null
            }
            {
              (productsSold)
              ? <tbody>
                  <tr>
                    <td></td>
                    <td></td>
                    <th>Total</th>
                    <th style={{textAlign: 'right'}}>P{formatNumber(totalSales)}</th>
                  </tr>
                </tbody>
              : null
            }
          </table>
        </div>
      </div>
      <TodaysSalesStyle />
    </React.Fragment>
  )
}

export default React.memo(TodaysSales)